import React from 'react';
import { Flex, Text, Toggle, Pane, Toast, Label } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import S from './AutomaticLocationTransferCard.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class AutomaticLocationTransferCard extends React.Component {
  constructor(props) {
    super(props);
    const {
      sharedProps: {
        item,
        actions
      }
    } = props;
    this.actions = actions;
    this.state = {
      loading: false,
      enabled: !!item?.data?.autoTransferEnabled
    };
  }
  async onToggle() {
    const {
      enabled
    } = this.state;
    this.setState({
      enabled,
      loading: true
    });
    try {
      await GlobalState.dispatch(this.actions.update({
        data: {
          autoTransferEnabled: !enabled
        }
      }));
      this.setState(state => {
        return {
          enabled: !enabled,
          loading: false
        };
      });
    } catch (err) {
      console.error(err);
      Toast.error('Error updating Automatic Location Transfer');
    }
  }
  render() {
    const {
      enabled,
      loading
    } = this.state;
    return /*#__PURE__*/_jsx(Pane, {
      variant: "dataCard",
      className: S.pane,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "detailLabel",
          children: "If a vehicle is offsite from its current location and reports a position that is within the zone of another location of this company, the system will automatically transfer the vehicle & locator to that new location if it remains in that zone after 24 hours have passed."
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "rowL",
          children: [/*#__PURE__*/_jsx(Toggle, {
            variant: "default",
            value: enabled,
            disabled: loading,
            eventData: "enabled",
            onChange: () => this.onToggle()
          }), /*#__PURE__*/_jsx(Label, {
            variant: "inputCaption",
            className: S.label,
            children: enabled ? 'Disable Automatic Location Transfer' : 'Enable Automatic Location Transfer'
          })]
        })]
      })
    });
  }
}